import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { getMaxBillableCount } from "../http/requests/project-admin";
import { ProjectAdminType, setVtrackLoader, setMaxBillableCount } from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";

function* workerGetMaxBillableCountSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    const res = yield call(getMaxBillableCount, payload.projectId);
    yield put(setMaxBillableCount(res.data));
    yield put(setVtrackLoader(false));
  } catch (err) {
    toast.error(err.data.errorMessage, toastOptions);
    yield put(setVtrackLoader(false));
  }
}

export function* getMaxBillableCountSaga() {
  yield takeLatest(
    ProjectAdminType.GET_MAX_BILLABLE_COUNT,
    workerGetMaxBillableCountSaga
  );
}
